import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Picture, PictureComponent } from './picture.component';



@NgModule({
  declarations: [
    PictureComponent,
    Picture
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PictureComponent,
    Picture
  ]
})
export class PictureModule { }
